import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { getErrorMessage } from '../../utils/errorHandler';
import mailingAPI, { MailingPayload } from './mailingAPI';

interface MailingState {
  status: 'loading' | 'idle' | 'error';
  error?: string;
  message?: string;
}

export const initialState: MailingState = {
  status: 'idle',
};

export const confirmMailing = createAsyncThunk<
  null,
  MailingPayload,
  { rejectValue: string }
>('mailing/', async (data, thunkAPI) => {
  try {
    const response = await mailingAPI.confirmMailing(data);

    if (response.status === 'error') {
      return thunkAPI.rejectWithValue(response.error);
    }

    return response.data;
  } catch (err) {
    console.error(err);
    return thunkAPI.rejectWithValue(getErrorMessage(err));
  }
});

export const MailingState = createSlice({
  name: 'MailingState',
  initialState,
  reducers: {
    cleanMailingState(state) {
      state.status = 'idle';
      state.message = '';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(confirmMailing.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(confirmMailing.fulfilled, (state) => {
        state.status = 'idle';
        state.message =
          'Verifique su correo electrónico para finalizar la suscripción de boleta por mail!';
      })
      .addCase(confirmMailing.rejected, (state, action) => {
        state.status = 'error';
        state.error = action.payload;
      });
  },
});

export const mailingError = (state: RootState) => state.mailing.error;
export const mailingMessage = (state: RootState) => state.mailing.message;
export const mailingStatus = (state: RootState) => state.mailing.status;
export const { cleanMailingState } = MailingState.actions;

export default MailingState.reducer;
